/* =====================================================================
   Prezzi visibili nel configuratore - 26 AGO 2026
   (il file si chiama prezzo-testata per ragioni storiche: dentro ci
   sono tutte e tre le regole che governano DOVE si vedono i prezzi)

   Serve a far funzionare il configuratore custom con la stessa dinamica
   del bundle Kaching che gira su /products/kit-de-inicio, che e' quella
   che oggi vende:

     - un prezzo solo per pacchetto, ben visibile: 39,99 / 49,99 / 69,99
     - gli order bump elencati con il LORO prezzo accanto (PRO 9,99)
     - nessuna somma da nessuna parte: il pulsante Kaching dice solo
       "ANADIR AL CARRITO", senza cifre
     - il totale compare per la prima volta nel carrello

   Il configuratore faceva l'opposto: il prezzo grande in alto era il
   totale accessori compresi (59,94) e lo stesso totale stava anche sul
   pulsante. Risultato: nessuno dei due numeri era il prezzo del
   pacchetto, e con la testata corretta se ne vedevano due diversi.

   TRE REGOLE
   1) la testata mostra il kit senza accessori
   2) il pulsante di acquisto non mostra nessun prezzo
   3) il prezzo dell'accessorio resta scritto sulla sua scheda anche
      quando e' gia' scelto

   La 3 non e' un dettaglio: e' quella che tiene onesta la 2. Se togli
   la somma dal pulsante, il prezzo del PRO deve restare leggibile dove
   sta il PRO - ed e' esattamente quello che fa Kaching, dove la riga
   del bump mostra sempre 9,99 barrato 19,99, scelto o no.

   PERCHE' UN GANCIO E NON 25 MODIFICHE
   In sections/starter-kit.liquid il prezzo di testata viene riscritto
   in venticinque punti diversi, sempre in coppia con quello del
   pulsante. Toccarli tutti significava venticinque occasioni di
   sbagliare, dentro un file gia' a un passo dal limite di 256 KB. Qui
   intercettiamo una volta sola la scrittura su #product-price.
   ===================================================================== */
(function () {
  var radice = document.querySelector('[data-ab-prezzo-testata]');
  if (!radice) return;

  var SENZA_ACCESSORI = radice.dataset.senzaAccessori === '1';
  var BOTTONE_MUTO = radice.dataset.bottoneMuto === '1';
  var PREZZO_SEMPRE = radice.dataset.prezzoSempre === '1';
  var BADGE = radice.dataset.badge === '1';
  var SEL_STEP_3 = '.custom-journey-pack .step.step-3';

  var nativo = Object.getOwnPropertyDescriptor(Node.prototype, 'textContent');
  if (!nativo || !nativo.set) return;

  /* Due decimali obbligatori: cosi' un'etichetta come "1. Selecciona"
     non viene scambiata per un prezzo. Se non troviamo un prezzo non
     tocchiamo niente: il caso peggiore e' tornare al comportamento di
     prima, mai un numero sbagliato. */
  var NUMERO = /(\d+[.,]\d{2})/;

  /* Il mercato usa la virgola o il punto? Lo si chiede a Shopify invece
     di indovinarlo dalla lingua: data-campione e' 1,99 gia' formattato
     dal filtro money del mercato corrente. */
  var VIRGOLA = String(radice.dataset.campione || '').indexOf(',') > -1;

  function comeIlMercato(n) {
    var t = n.toFixed(2);
    return VIRGOLA ? t.replace('.', ',') : t;
  }

  function prezzoAccessori() {
    /* stessa logica di accssoriesPrice() nella sezione */
    var totale = 0;
    var scelti = document.querySelectorAll('.custom-journey-pack .acc-select.selected');
    for (var i = 0; i < scelti.length; i++) {
      var scheda = scelti[i].closest('.fum-journeypdp-variant-selectable');
      if (scheda) totale += Number(scheda.dataset.price) || 0;
    }
    return totale;
  }

  /* ------------------------------------------------------------------
     1) LA TESTATA SENZA ACCESSORI
     ------------------------------------------------------------------ */

  var testata = document.querySelector('#custom-product .item-price #product-price');
  var barrato = document.querySelector('#custom-product .otp-cut-price');
  var ultimoLordo = null;   /* l'ultimo valore scritto dal tema */
  var ultimoNetto = null;   /* l'ultimo valore scritto da noi */

  /* Il barrato ha lo stesso problema, con in piu' una trappola: la
     funzione del tema che lo calcola fa Number("49,95") dopo aver letto
     la testata, e con la virgola quel Number e' NaN. Finche' scriveva
     lui, il barrato passava per un istante da un valore assurdo.

     Quindi il barrato lo scriviamo solo noi: intercettiamo anche il suo
     textContent e, qualunque cosa il tema provi a metterci, rifacciamo
     il conto dalla testata. Nessuna recursione, perche' scriviamo con
     il setter nativo che salta la nostra stessa proprieta'. */
  function scriviBarrato() {
    if (!barrato || !testata) return;
    var trovato = String(nativo.get.call(testata)).match(NUMERO);
    if (!trovato) return;
    var n = parseFloat(trovato[1].replace(',', '.'));
    if (!isFinite(n)) return;
    nativo.set.call(barrato, comeIlMercato(n * 2));
  }

  if (barrato) {
    Object.defineProperty(barrato, 'textContent', {
      configurable: true,
      get: function () { return nativo.get.call(this); },
      set: function () { scriviBarrato(); }
    });
  }

  /* Perche' il prezzo cambiava due volte, prima col punto e poi con la
     virgola. La prima scrittura era del tema, che formatta i numeri col
     punto e a volte parte da un totale non ancora aggiornato; la
     seconda era nostra, qualche decina di millisecondi dopo, con la
     virgola e il totale giusto. Due mani sullo stesso numero.

     Adesso scrive una mano sola. Nel punto esatto in cui il tema tocca
     la testata, il totale sul pulsante e' gia' quello nuovo - il tema
     lo aggiorna una riga prima, sempre - quindi partiamo da li' e non
     dal valore che ci passa. Il separatore lo decide il mercato via
     comeIlMercato(). Il numero giusto, nel formato giusto, alla prima
     scrittura: niente da correggere dopo. */
  function scrivi(lordo) {
    var testo = String(lordo == null ? '' : lordo);
    ultimoLordo = testo;

    var trovato = testo.match(NUMERO);
    if (!trovato) {           /* e' un'etichetta, non un prezzo */
      ultimoNetto = testo;
      nativo.set.call(testata, testo);
      return;
    }

    var passato = parseFloat(trovato[1].replace(',', '.'));
    var totale = totaleDalPulsante();
    var base = totale !== null ? totale : passato;
    var netto = SENZA_ACCESSORI ? base - prezzoAccessori() : base;
    if (!isFinite(netto) || netto <= 0) netto = passato;

    ultimoNetto = testo.replace(trovato[1], comeIlMercato(netto));
    nativo.set.call(testata, ultimoNetto);
    scriviBarrato();
  }

  if (testata) {
    Object.defineProperty(testata, 'textContent', {
      configurable: true,
      get: function () { return nativo.get.call(this); },
      set: function (v) { scrivi(String(v == null ? '' : v)); }
    });
  }

  /* ------------------------------------------------------------------
     4) IL BADGE DELLO SCONTO A SINISTRA DEL PREZZO
     Due scopi in uno: dice quanto si risparmia, e riporta il prezzo al
     centro. Prima il gruppo prezzo + barrato pendeva a sinistra perche'
     il barrato sta tutto a destra del prezzo grande; con il badge
     dall'altra parte il baricentro torna a posto.

     La percentuale non e' scritta a mano: si ricava dal barrato, quindi
     se un domani cambia il modo di calcolarlo il badge lo segue invece
     di mentire.

     Lo stile e' quello di .image-badge in assets/custom.css - la stessa
     etichetta gialla obliqua del "50%" su The Bond - resa in riga
     invece che appiccicata a un angolo.
     ------------------------------------------------------------------ */

  var badge = null;

  function percentualeSconto() {
    if (!testata || !barrato) return 0;
    var a = String(nativo.get.call(testata)).match(NUMERO);
    var b = String(nativo.get.call(barrato)).match(NUMERO);
    if (!a || !b) return 0;
    var prezzo = parseFloat(a[1].replace(',', '.'));
    var pieno = parseFloat(b[1].replace(',', '.'));
    if (!isFinite(prezzo) || !isFinite(pieno) || pieno <= prezzo) return 0;
    return Math.round((1 - prezzo / pieno) * 100);
  }

  function aggiornaBadge() {
    if (!BADGE || !testata) return;
    var contenitore = testata.closest('.price-container');
    if (!contenitore) return;
    if (!badge) {
      badge = document.createElement('span');
      /* NIENTE .image-badge: quella e' l'etichetta gialla obliqua usata
         gia' dal "50%" di The Bond e dai badge degli step. Lo sconto
         deve essere l'unico elemento con un linguaggio suo, altrimenti
         si confonde con il resto e smette di saltare all'occhio. */
      badge.className = 'ab-badge-sconto ab-badge-sconto--' + (radice.dataset.badgeStile || 'rosso-pieno');
      contenitore.insertBefore(badge, contenitore.firstChild);
    }
    var n = percentualeSconto();
    badge.hidden = n <= 0;
    if (n > 0) {
      badge.textContent = String(radice.dataset.badgeTesto || '-{n}%').replace('{n}', n);
    }
  }

  /* ------------------------------------------------------------------
     3) IL PREZZO NEL PULSANTE DELL'ACCESSORIO, SEMPRE
     Il tema scrive il prezzo DENTRO il pulsante: "+9,99" quando non e'
     scelto, "ELEGIDO" quando lo e'. Cosi' il prezzo del PRO sparisce
     proprio quando conta, cioe' quando e' gia' nel carrello. Glielo
     rimettiamo di fianco, nello stesso pulsante e con lo stesso stile:
     "ELEGIDO . +9,99", con il pallino separatore che avevamo tolto dal
     pulsante di acquisto.
     ------------------------------------------------------------------ */

  function schedeAccessori() {
    return Array.prototype.slice.call(
      document.querySelectorAll(SEL_STEP_3 + ' .flavor')
    );
  }

  function segnaPrezzi() {
    if (!PREZZO_SEMPRE) { normalizzaDecimali(); return; }
    schedeAccessori().forEach(function (scheda) {
      if (scheda.dataset.isAccessorySelected !== 'true') return;
      var contenitore = scheda.querySelector('.fum-journeypdp-variant-selectable') || scheda;
      /* 30 AGO 2026 - con The Bond certi accessori valgono due: si chiede
         a chi lo sa (accessori-extra.js), invece di riscrivere qui la
         stessa regola una seconda volta. */
      var quante = (window.abAccessori && window.abAccessori.quante) ? window.abAccessori.quante(scheda) : 1;
      var prezzo = (Number(contenitore.dataset.price) || 0) * quante;
      if (!prezzo) return;
      var bottone = scheda.querySelector('.acc-select');
      var etichetta = bottone && bottone.querySelector('span');
      if (!etichetta) return;
      /* Si taglia sempre a partire dal pallino, quindi rigirare la
         funzione mille volte lascia lo stesso testo: "ELEGIDO" torna
         "ELEGIDO" e non "ELEGIDO . 9,99 . 9,99". */
      var base = etichetta.textContent.split('\u2022')[0].replace(/\s+$/, '');
      if (!base) return;
      /* Senza il "+": il piu' ha senso finche' l'accessorio e' da
         aggiungere ("+9,99"), ma una volta scelto e' gia' dentro, e
         "ELEGIDO . +9,99" si legge come se stesse per aggiungerne un
         altro. Da scelto resta il prezzo e basta. */
      etichetta.textContent = base + ' \u2022 ' + (radice.dataset.valuta || '') + comeIlMercato(prezzo);
    });
    normalizzaDecimali();
  }

  /* Al primo disegno il prezzo dell'accessorio lo scrive Liquid e usa la
     virgola; quando il tema lo riscrive in JS usa il punto. Risultato:
     lo stesso accessorio mostra "+9,99" o "+9.99" a seconda di quante
     volte ci hai cliccato sopra. Qui si rimette la virgola. */
  function normalizzaDecimali() {
    if (!VIRGOLA) return;
    var bottoni = document.querySelectorAll(SEL_STEP_3 + ' .acc-select span');
    for (var i = 0; i < bottoni.length; i++) {
      var testo = bottoni[i].textContent;
      var corretto = testo.replace(/(\d)\.(\d{2})(?!\d)/g, '$1,$2');
      if (corretto !== testo) bottoni[i].textContent = corretto;
    }
  }

  /* ------------------------------------------------------------------
     2) IL PULSANTE SENZA PREZZO
     La cifra la nasconde il CSS (prezzo-testata.css): cosi'
     airbreazy-configuratore.js, che aggiunge il pallino separatore solo
     se il prezzo si vede, si adegua da solo senza saperne niente.
     ------------------------------------------------------------------ */

  if (BOTTONE_MUTO) document.documentElement.classList.add('ab-bottone-muto');

  /* ------------------------------------------------------------------ */

  /* IL TOTALE VERO STA SUL PULSANTE
     Il pulsante di acquisto continua a ricevere dal tema il totale
     giusto, accessori compresi: lo nasconde il CSS, ma il numero e' li'
     e non lo tocca nessuno. E' la fonte piu' affidabile che abbiamo.

     Serviva perche' fidarsi del valore passato al setter non bastava:
     scegliendo il secondo accessorio il tema riscriveva la testata con
     il totale VECCHIO mentre gli accessori erano gia' due, e la
     sottrazione portava 59,94 a 39,96 invece che a 49,95. Da li' non si
     riprendeva piu', perche' quel valore sbagliato diventava il nuovo
     punto di partenza. Rileggendo il totale dal pulsante il conto si
     raddrizza da solo al giro dopo, qualunque cosa sia successa. */
  function totaleDalPulsante() {
    var e = document.querySelector('.custom-journey-pack #add-to-cart-submit-button #add-to-cart-price');
    if (!e) return null;
    var trovato = String(e.textContent).match(NUMERO);
    if (!trovato) return null;
    var n = parseFloat(trovato[1].replace(',', '.'));
    return isFinite(n) ? n : null;
  }

  /* Un solo percorso: si riparte sempre dal totale del pulsante e si
     passa da scrivi(), che sa gia' togliere gli accessori e formattare.
     Prima riallinea() rifaceva il conto per conto suo e le due copie
     potevano divergere. */
  function riallinea() {
    if (testata) {
      var totale = totaleDalPulsante();
      if (totale !== null) scrivi(' ' + (radice.dataset.valuta || '') + comeIlMercato(totale));
    }
    segnaPrezzi();
    aggiornaBadge();
  }

  riallinea();

  document.addEventListener('click', function () {
    setTimeout(riallinea, 60);
    setTimeout(riallinea, 260);
    setTimeout(riallinea, 700);
  }, true);
  window.addEventListener('load', riallinea);

  /* I prezzi dentro ai pulsanti degli accessori li riscrive il tema, e
     li riscrive col punto. Aspettare i timer voleva dire vedere "+9.99"
     per un istante e poi "+9,99". L'osservatore reagisce alla modifica
     prima che il browser ridisegni, quindi il punto non si vede mai. */
  var zonaAccessori = document.querySelector(SEL_STEP_3);
  if (zonaAccessori && window.MutationObserver) {
    var inCorsoNormalizza = false;
    new MutationObserver(function () {
      if (inCorsoNormalizza) return;
      inCorsoNormalizza = true;
      normalizzaDecimali();
      inCorsoNormalizza = false;
    }).observe(zonaAccessori, { subtree: true, childList: true, characterData: true });
  }
})();
